import React from "react";
import PropTypes from "prop-types";
import Fieldset from "../../common/Fieldset";
import DownloadUploadFiles from "../../common/DownloadUploadFiles";
import TextAreaInput from "../../common/TextAreaInput";
import FieldsetSubHeader from "../../common/FieldsetSubHeader";

import * as domainConstants from "../../../constants/DomainConstants";

const EenCampusmodelForm = props => {

    const EENCAMPUSMODEL_TOOLTIP = "In zoverre mogelijk kan een centralisatie in één van de drie Vlaamse topsportcampussen (driehoek Gent-Antwerpen-Leuven) en/of een clustering van meerdere sporttakken jouw dossier versterken.";
    const {
        beoordelingscriteria,
        disabled,
        errors,
        onChange,
        color,
        fileTypes,
        mapDeleteFile,
        mapDropFiles,
        getFilesForDossierComponent,
        fileSessionStarted,
        validationMessageType
    } = props;

    return (
        <Fieldset
            title="Eén-campusmodel">
            <FieldsetSubHeader>Toon aan in welke mate de topsporttrainingsinfrastructuur tegemoet komt aan de uitbouw van een één-campus-model topsport voor de betrokken sporttak of sportdiscipline in kwestie, of aan de uitbouw van een volwaardig topsporttrainingscentrum voor meerdere topsportfederaties (topsportcampus). Beschrijf daarbij in welke mate de gecentraliseerde topsportwerking wenselijk en realiseerbaar is, met mogelijkheid tot koppeling van het trainingscentrum aan gepaste leefaccommodatie (leven, trainen en studeren op één locatie), de topsportschool, sportkaderopleidingen, organisatie van stages, centralisatie van de sportwetenschappelijke omkadering, ...
            </FieldsetSubHeader>
            <TextAreaInput
                name="mateVanTegemoetkomingAanCampusmodel"
                label="Eén campusmodel (max. 2.000 tekens)"
                value={beoordelingscriteria.mateVanTegemoetkomingAanCampusmodel}
                onChange={onChange}
                height={5}
                disabled={disabled}
                tooltip={EENCAMPUSMODEL_TOOLTIP}
                validationMessage={errors ? errors.mateVanTegemoetkomingAanCampusmodel : ""}
                validationMessageType={validationMessageType} />

            <DownloadUploadFiles
                dossierId={beoordelingscriteria.dossierId}
                title="Eén-campusmodel"
                center
                optional
                disabled={disabled}
                color={color}
                tab={domainConstants.DocumentTab.Criteria}
                component={domainConstants.ComponentName.Campusmodel}
                onDelete={mapDeleteFile(domainConstants.ComponentName.Campusmodel)}
                onDrop={mapDropFiles(domainConstants.ComponentName.Campusmodel)}
                files={getFilesForDossierComponent(domainConstants.ComponentName.Campusmodel)}
                fileTypes={fileTypes.Campusmodel}
                validationMessage={errors ? errors.ulCampusModel : ""}
                fileSessionStarted={fileSessionStarted}
                validationMessageType={validationMessageType} />
        </Fieldset>
    );
};

EenCampusmodelForm.propTypes = {
    beoordelingscriteria: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    errors: PropTypes.object,
    color: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    fileTypes: PropTypes.object,
    mapDeleteFile: PropTypes.func.isRequired,
    mapDropFiles: PropTypes.func.isRequired,
    getFilesForDossierComponent: PropTypes.func.isRequired,
    fileSessionStarted: PropTypes.bool,
    validationMessageType: PropTypes.string
};

export default EenCampusmodelForm;


